.container {
  @media (--md-up) {
    position: relative;

    &::before {
      position: absolute;
      top: 0.5rem;
      left: 50%;
      width: 1px;
      height: calc(100% + 1.5rem);
      content: "";
      border: 1px solid var(--gray-400);
      transform: translateX(-50%);
    }
  }
}

.title {
  font-size: 2.5rem;
}

.top {
  width: 100%;
  padding: 0 1rem;
  overflow: hidden;
}

.nav {
  background-color: white;

  @media print {
    display: none;
  }
}

.layout {
  @media print {
    /* make charts print properly
     * https://stackoverflow.com/a/47928475/13256833 */
    canvas {
      width: auto !important;
      max-width: 100%;
      height: auto !important;
      min-height: 100%;
      max-height: 100%;
    }
  }
}

.break {
  break-inside: avoid;
}
